import getNotificationConfig from "./getNotificationConfig";
import getUnreviewedAppNotificationDescription from "./getUnreviewedAppNotificationDescription";
import playNotificationSound from "./playNotificationSound";

const showUnreviewedAppNotification = (notificationAPI, options) => {
  const config = getNotificationConfig('unreviewedApps')
  const description = getUnreviewedAppNotificationDescription(options)
  playNotificationSound('unreviewedApps')
  notificationAPI.info({...config, description})
}

export default showUnreviewedAppNotification;